"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _solarReact = require("@solar/solar-react");

var _styles = require("@material-ui/core/styles");

var _CertificateListItem = _interopRequireWildcard(require("./CertificateListItem"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    pdf: {
      top: 8,
      right: 8,
      zIndex: 999
    }
  };
});

var CertificateCardList = function CertificateCardList(_ref) {
  var certificates = _ref.certificates,
      openCertificate = _ref.openCertificate,
      unit = _ref.unit,
      manufacturer = _ref.manufacturer,
      noMedia = _ref.noMedia,
      labels = _ref.labels;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_solarReact.CardList, {
    items: certificates
  }, function (certificate) {
    return /*#__PURE__*/_react["default"].createElement(_CertificateListItem["default"], _extends({
      noMedia: noMedia,
      key: certificate._id,
      onClick: function onClick() {
        return openCertificate(certificate.key);
      }
    }, (0, _CertificateListItem.certificateMapper)(certificate, unit, manufacturer, labels), {
      coverTitle: manufacturer && manufacturer.title,
      pdfWidth: 80,
      classes: {
        pdf: classes.pdf
      }
    }));
  });
};

var _default = CertificateCardList;
exports["default"] = _default;